import { useMemo } from 'react';
import { l as lib } from '../3rdPartyModules/json5/dist/index-BGIcOBpq.js';
import { useStormError } from '@amzn/storm-ui';

const useHelpInfo = () => {
  const {
    throwStormError
  } = useStormError();
  return useMemo(() => {
    if (typeof document === 'undefined' || !document) {
      return null;
    }
    try {
      var _document$querySelect, _document;
      const scripts = (_document$querySelect = (_document = document) === null || _document === void 0 ? void 0 : _document.querySelectorAll('script')) !== null && _document$querySelect !== void 0 ? _document$querySelect : [];
      const helpInfo = Array.from(scripts).map(script => script.textContent || '').filter(scriptContent => !!scriptContent).map(scriptContent => {
        try {
          const regex = /['"]?helpInfo['"]?\s*[:=]\s*(\[[^]*?\])/;
          const match = scriptContent.match(regex);
          if (!(match !== null && match !== void 0 && match[1])) {
            return null;
          }
          const parsedData = lib.parse(match[1]);
          if (!Array.isArray(parsedData)) {
            throwStormError('useHelpInfo', 'Could not parse helpInfo from script: helpInfo must be an array');
            return null;
          }
          if (!isHelpInfoArray(parsedData)) {
            throwStormError('useHelpInfo', 'Could not parse helpInfo from script: Invalid helpInfo array structure');
            return null;
          }
          return parsedData;
        } catch (error) {
          throwStormError('useHelpInfo', `Could not parse helpInfo from script: ${error.message}`);
          return null;
        }
      }).find(result => result !== null);
      return helpInfo || null;
    } catch (error) {
      throwStormError('useHelpInfo', `Could not parse helpInfo from script: ${error.message}`);
      return null;
    }
  }, [throwStormError]);
};

// Type guard for HelpInfo array
function isHelpInfoArray(data) {
  return Array.isArray(data) && data.every(item => item !== null && typeof item === 'object' && typeof item.label === 'string' && typeof item.url === 'string' && (item.id === undefined || typeof item.id === 'string') && (item.isExternal === undefined || typeof item.isExternal === 'boolean') && (item.uid === undefined || typeof item.uid === 'string'));
}

export { useHelpInfo as u };
//# sourceMappingURL=useHelpInfo-DSBDDgvL.js.map
